// Keep localized placeholders out of song data and creation inputs.
export function songTagLabels(tags) {
  return typeof tags === 'string' ? tags.split(',').map(tag => tag.trim()).filter(Boolean) : [];
}

export function songRawTags(tags) {
  return songTagLabels(tags).length ? tags : '';
}

export function songSeoTagText(tags, fallback) {
  return songRawTags(tags) ? tags.split(',').map(tag => tag.trim()).join(',') : fallback;
}
